import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export class DayJsWrapper {
    static format(date: Date | undefined, format: string): string {
        if (!date) {
            return '';
        }
        return dayjs(date).format(format || '');
    }

    static utcString(date: Date | undefined): string {
        if (!date) {
            return '';
        }
        return dayjs.utc(date).format('YYYY-MM-DDTHH:mm:ss');
    }

    static fromLocaleToTimeZone(date: Date, timeZone: string): Date {
        return (dayjs(date).tz(timeZone) as any).$d as Date;
    }

    static fromTimeZoneToLocale(date: Date, timeZone: string): Date {
        return dayjs(date).tz(timeZone, true).toDate();
    }
}
